export default "__VITE_ASSET__9f71633a__"